{
	"main": {
		"title": "Dnevni razpored",
		"subtitle1": "RAZPORED LETENJA:",
		"subtitle2": "OPOZORILO",
		"subSubtitle2": "ZA OSTALE AKTIVNOSTI V ZRAKU:",
		"nazaj": "Nazaj"
	},
	"nav": {
		"vnos": "Vnos",
		"zapisi": "Zapisi"
	},
	"labels": {
		"planirano": "Planirano (Ruta, Š.krog, Šolanje,..)",
		"sredstvoTitle": "Sredstvo:",
		"sredstvo": "",
		"izvrsilec": "Izvršilec (Ime, Priimek)",
		"vrstaLetala": "Izberi vrsto letala : ",
		"casAktivnosti": "Čas aktivnosti :",
		"opisAktivnosti": "Opis aktivnosti (npr. Padalci v zoni letališča..)",
		"naloga": "Izberi nalogo :"
	},
	"buttons": {
		"dodajSredstvo": "Dodaj sredstvo",
		"vnesiRazpored": "Vnesi v razpored",
		"vnesiOpozorilo": "Vnesi opozorilo",
		"brisiIzbiro": "Pobriši izbiro"
	},
	"obvestila": {
		"brisiSredstvo": "Ali res želiš izbrisati sredstvo?",
		"vnosUspesen": "vnos uspešen",
		"vnosNeuspesen": "Napaka pri vnosu podatkov.",
		"napakaInputa": "Niste izpolnili vseh polj! Izponite vsa polja!"
	}
}